import { Helmet } from "react-helmet-async"
import { Lightbulb, Target, Scale } from "lucide-react"
import { Badge } from "../../components/ui/badge"
export default function VisionMission() {
  return (
    <>
      <Helmet>
        <title>Vision & Mission - Pranaam Hospitals</title>
      </Helmet>
      
      <main className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-primary/10 to-primary/5 py-16 md:py-24">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto text-center">
              <Badge className="mb-4 px-3 py-1">Our Purpose</Badge>
              <h1 className="mb-6 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
                Vision & <span className="text-primary">Mission</span>
              </h1>
              <p className="mb-8 text-lg text-gray-700 max-w-3xl mx-auto">
                Our journey is guided by a commitment to excellence and a mission to provide compassionate, high-quality healthcare to every individual.
              </p>
            </div>
          </div>
        </section>

        <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-6xl mx-auto">
            
            <div className="grid md:grid-cols-3 gap-8">
              
              {/* Vision */}
              <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
                <div className="flex justify-center mb-6">
                  <div className="w-20 h-20 md:w-24 md:h-24 rounded-full border-4 border-red-600 flex items-center justify-center">
                    <Lightbulb className="w-10 h-10 md:w-12 md:h-12 text-red-600" />
                  </div>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-6 text-center">VISION</h2>
                <p className="text-gray-700 leading-relaxed text-center">
                  To be the go-to destination for excellence and innovation in healthcare.
                </p>
              </div>

              {/* Mission */}
              <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
                <div className="flex justify-center mb-6">
                  <div className="w-20 h-20 md:w-24 md:h-24 rounded-full border-4 border-red-600 flex items-center justify-center">
                    <Target className="w-10 h-10 md:w-12 md:h-12 text-red-600" />
                  </div>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-6 text-center">MISSION</h2>
                <p className="text-gray-700 leading-relaxed text-center">
                  Nothing is more rewarding than the heart-felt gratitude from our patients and their loves when we help restore their health and live better lives. This helps us set the bar even higher for ourselves by delivering compassionate and seamless care at all times.
                </p>
              </div>

              {/* Values */}
              <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
                <div className="flex justify-center mb-6">
                  <div className="w-20 h-20 md:w-24 md:h-24 rounded-full border-4 border-red-600 flex items-center justify-center">
                    <Scale className="w-10 h-10 md:w-12 md:h-12 text-red-600" />
                  </div>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-6 text-center">VALUES</h2>
                <p className="text-gray-700 mb-4 text-center">
                  The core values ingrained deep in our system, drives us to offer the best healthcare services through:
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Trust</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Commitment</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Compassion</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Excellence</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Integrity</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Respect</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-red-600 mr-2">•</span>
                    <span>Teamwork</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </main>
    </>
  )
}
